import { ActionTypes } from "../../constants/action-types";

const initialState = {
  performance: [],
  is_performance: false,
  sendMyProfile: [],
};

export const performanceReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_PERFORMANCE:
      return {
        ...state,
        is_performance: true,
        performance: payload,
      };
    case ActionTypes.RESET_STORE:
      return {
        ...(state = initialState),
      };
    case ActionTypes.FETCH_SEND_MY_PROFILE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ActionTypes.FETCH_SEND_MY_PROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        sendMyProfile: payload,
      };
    case ActionTypes.FETCH_SEND_MY_PROFILE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    default:
      return state;
  }
};

// export const sendMyProfileReducer = (
//   state = initialState,
//   { type, payload }
// ) => {
//   switch (type) {
//     case ActionTypes.FETCH_SEND_MY_PROFILE_REQUEST:
//       return {
//         ...state,
//         isLoading: true,
//       };
//     case ActionTypes.FETCH_SEND_MY_PROFILE_SUCCESS:
//       return {
//         ...state,
//         isLoading: false,
//         sendMyProfile: payload,
//       };
//     case ActionTypes.FETCH_SEND_MY_PROFILE_FAILURE:
//       return {
//         ...state,
//         isLoading: false,
//         error: payload,
//       };
//     default:
//       return state;
//   }
// };
